/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */
import { ModalField } from './modalField';
import {
  defaultPinDigit, defaultPinSegment, SEGMENT_LETTERS, SEGMENT_LETTER_TO_INDEX,
} from './display7SegmentsData';
import './display7SegmentsModal.scss';

export class Display7SegmentsModal extends ModalField {
  name_ = 'Display7Segments';

  blockWidth_ = 140;

  blockHeight_ = 135;

  painting_ = false;

  pinDigit() {
    return (this.value_ && this.value_.pinDigit) ? this.value_.pinDigit : defaultPinDigit();
  }

  pinSegment() {
    return (this.value_ && this.value_.pinSegment) ? this.value_.pinSegment : defaultPinSegment();
  }

  setDigitPin(index, pin) {
    const pinDigit = this.pinDigit().map((d, i) => (i === index ? { ...d, pin } : d));
    this.setValue({ ...this.value_, pinDigit });
  }

  setDigitState(index, state) {
    const pinDigit = this.pinDigit().map((d, i) => (i === index ? { ...d, state } : d));
    this.setValue({ ...this.value_, pinDigit });
    this.paintBlockContent();
  }

  setSegmentPin(index, pin) {
    const pinSegment = this.pinSegment().map((s, i) => (i === index ? { ...s, pin } : s));
    this.setValue({ ...this.value_, pinSegment });
  }

  setSegmentState(index, state) {
    const pinSegment = this.pinSegment().map((s, i) => (i === index ? { ...s, state } : s));
    this.setValue({ ...this.value_, pinSegment });
    this.paintBlockContent();
  }

  renderRows(segments, editable) {
    const on = (i) => (segments[i] && segments[i].state ? 'led-on' : '');
    const idx = (i) => (editable ? ` data-index="${i}"` : '');
    return `
      <div class="row-horizontal">
        <div class="col-left"></div>
        <div class="col-center led ${on(0)}"${idx(0)}></div>
        <div class="col-right"></div>
      </div>
      <div class="row-vertical">
        <div class="col-left led ${on(1)}"${idx(1)}></div>
        <div class="col-center"></div>
        <div class="col-right led ${on(2)}"${idx(2)}></div>
      </div>
      <div class="row-horizontal">
        <div class="col-left"></div>
        <div class="col-center led ${on(3)}"${idx(3)}></div>
        <div class="col-right"></div>
      </div>
      <div class="row-vertical">
        <div class="col-left led ${on(4)}"${idx(4)}></div>
        <div class="col-center"></div>
        <div class="col-right led ${on(5)}"${idx(5)}></div>
      </div>
      <div class="row-horizontal">
        <div class="col-left"></div>
        <div class="col-center led ${on(6)}"${idx(6)}></div>
        <div class="col-right"></div>
      </div>
    `;
  }

  renderBlockContent_() {
    return `<div class="sevenSegments-mini"><div class="container">${this.renderRows(this.pinSegment(), false)}</div></div>`;
  }

  renderDigits() {
    return this.pinDigit().map((d, i) => `
      <label>&nbsp;${i + 1}
        <div class="digit-enable ${d.state ? 'selected' : ''}" data-digit="${i}">
          <input type="text" maxlength="2" class="pin" data-digit-pin="${i}" value="${d.pin}" />
          <span class="digit-button icon-${d.state ? 'check' : 'minus'}-square" data-digit-button="${i}"></span>
        </div>
      </label>
    `).join('');
  }

  renderSegmentInputs() {
    const segments = this.pinSegment();
    return SEGMENT_LETTERS.map((letter) => {
      const index = SEGMENT_LETTER_TO_INDEX[letter];
      return `
        <label>${letter}
          <input type="text" maxlength="2" class="pin" data-segment-pin="${index}" value="${segments[index].pin}" />
        </label>
      `;
    }).join('');
  }

  renderModalContent_() {
    return `
      <div class="sevenSegments-close" title="Cerrar"><span class="icon-cross11"></span></div>
      <div class="pin-selector-digit">
        <div class="upper">${this.renderDigits()}</div>
      </div>
      <div class="pin-selector">
        <div class="upper">${this.renderSegmentInputs()}</div>
      </div>
      <div class="container">${this.renderRows(this.pinSegment(), true)}</div>
    `;
  }

  modal() {
    return document.querySelector(`.${this.name_}Modal`);
  }

  paintGrid() {
    const segments = this.pinSegment();
    const modal = this.modal();
    if (!modal) return;
    modal.querySelectorAll('.container .led[data-index]').forEach((cell) => {
      cell.classList.toggle('led-on', !!segments[Number(cell.dataset.index)].state);
    });
  }

  // Un valor inválido o vacío al salir del campo se revierte al último pin válido, como en prod.
  bindPinInput(input, currentPin, onCommit) {
    this.addEvent_(input, 'input', this, () => {
      if (input.value && /^[0-9]*$/.test(input.value)) {
        onCommit(parseInt(input.value, 10));
      }
    });
    this.addEvent_(input, 'blur', this, () => {
      if (!input.value || !/^[0-9]*$/.test(input.value)) {
        input.value = currentPin;
      }
    });
  }

  addCustomModalEvents() {
    const modal = this.modal();
    if (!modal) return;

    modal.querySelectorAll('.container .led[data-index]').forEach((cell) => {
      const index = Number(cell.dataset.index);

      this.addEvent_(cell, 'mousedown', this, (event) => {
        event.preventDefault();
        this.painting_ = !cell.classList.contains('led-on');
        this.setSegmentState(index, this.painting_);
        this.paintGrid();
      });

      this.addEvent_(cell, 'mouseover', this, (event) => {
        if (event.buttons !== 1) return;
        this.setSegmentState(index, this.painting_);
        this.paintGrid();
      });
    });

    modal.querySelectorAll('[data-digit-button]').forEach((button) => {
      this.addEvent_(button, 'mousedown', this, (event) => {
        event.preventDefault();
        const index = Number(button.dataset.digitButton);
        this.setDigitState(index, !this.pinDigit()[index].state);
      });
    });

    modal.querySelectorAll('[data-digit-pin]').forEach((input) => {
      const index = Number(input.dataset.digitPin);
      this.bindPinInput(input, this.pinDigit()[index].pin, (pin) => this.setDigitPin(index, pin));
    });

    modal.querySelectorAll('[data-segment-pin]').forEach((input) => {
      const index = Number(input.dataset.segmentPin);
      this.bindPinInput(input, this.pinSegment()[index].pin, (pin) => this.setSegmentPin(index, pin));
    });

    const close = modal.querySelector('.sevenSegments-close');
    this.addEvent_(close, 'click', this, () => {
      this.updateWorkspace();
      this.closeModal();
    });
  }
}
